<template>
  
</template>

<script>
export default {
mounted() {
  // 支付宝支付测试
  let res = `<form name="punchout_form" method="post" action="https://openapi.alipay.com/gateway.do?app_cert_sn=277da03732107954fc08d4fc4058bcb6&charset=UTF-8&encrypt_type=AES&alipay_root_cert_sn=687b59193f3f462dd5336e5abf83c5d8_02941eef3187dddf3d3b83462e1dfcf6&method=alipay.trade.wap.pay&sign=GGOLGk6dARNdfRYPZiubdcMsUchTfFlrelgJaM2m50TFFpcDWFCc6RCJo6CegNzSHtUL7MRswls7PVs%2FtR0PwHpREGpkN4o2hLegQlvq55y5mnCPOEhLPyjz45bga4hcZ7nRTW2Kd0%2FTNr%2BJw0Y9CknwKH8yBmySC9YOPEUwiMurhTUA61Y7mTneAW5o48rSmIDDYDNgbpyPK3JErqxjVf%2F8Wz%2F9MmNKRtlc4wwVb32q3Rov5f5YlG1trWYhoCOy4Hqrn2vwfYjv7MHquTHlgJSNzshZ5DgFvdEzrdVna0PvupUiTohkYpQKy%2F2OhFIk0LRgXGtzSVNPrFnDjiubaw%3D%3D&notify_url=https%3A%2F%2Fpre.yuan365.com%2Faigc-pay-notify%2Fnotify%2Falipay%2Fmoyin-alipay&version=1.0&app_id=2021003125658349&sign_type=RSA2&timestamp=2023-02-22+17%3A45%3A06&alipay_sdk=alipay-sdk-java-dynamicVersionNo&format=json">
        <input type="hidden" name="biz_content" value="bv6OAd9zuyfwNk1AGBel88tZ8WWRKvHqWF1xKm3Mkwxpew3XPFJx+RShrZinyigIpbv3LX6omifZln7FBU+RN3h2a7kZ7E9v4DLPgcCAKhWK90XeraoSNYd7PsJrFY3uS65PE3+au3vmd/+C8+WrP/r6P7Yz79KN9FK7M7T5JFjE1eFWXSh8ttJPVQn5pIvjw3v577ZhvhuPKpc2eH305Q==">
        <input type="submit" value="立即支付" style="display:none" >
        </form>`
      let div = document.querySelector("#payDiv");
      // 如果页面已经存在payDiv，则只要修改payDiv的innerHTML就可以了，否则提交的表单永远是第一个表单。
      if (!div) {
        div = document.createElement('div');
        div.id = "payDiv";
        document.body.appendChild(div);
      }
      div.innerHTML = res;
      const form = document.querySelector('#payDiv').children[0]
      form.submit()
}
}
</script>